import type { CSSProperties } from 'react';

/** Where a widget sits on the board and how it is being handled right now. */
export interface FrameState {
  rect: { left: number; top: number; width: number; height: number };
  dragging: boolean;
  resizing: boolean;
  animate: boolean;
  editing: boolean;
  collapsed: boolean;
  raised?: boolean;
}

export function frameStyle(f: FrameState): CSSProperties {
  return {
    left: f.rect.left,
    top: f.rect.top,
    width: f.rect.width,
    height: f.rect.height,
    zIndex: f.dragging || f.resizing ? 8 : f.raised ? 7 : 1,
    transition: f.dragging || f.resizing || !f.animate ? 'none' : 'left .18s, top .18s, width .18s, height .18s',
  };
}
